export const notificationUrls = {
  getNewNotification: '/api/Notify/GetNewNotification',
  getListNotify: '/api/Notify/GetListNotify',
  markAsSeen: '/api/Notify/MarkAsSeen',
  markAsRead: '/api/Notify/MarkAsRead',
  deleteNotification: '/api/Notify/DeleteNotification',
  subscribeSse: '/api/Notify/Subscribe',
}
